import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Button, Modal, Popover, Typography } from "@mui/material";
import {ViewList as ViewListIcon, Dashboard as DashboardIcon, Tune as TuneIcon} from "@mui/icons-material";
import CardShare from "./CardShare";
import ShareTable from "./ShareTable";
import EmptyPlanShare from "./EmptyPlanshare";
import http from "../../utils/http-common";
function SharePlan() {
  const [isClicked, setIsClicked] = useState(false);
  const [emptyUser, setEmptyUser] = useState(false);
  const [cardView, setCardView] = useState(true);
  const [gridView, setGridView] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setIsClicked(true);
  };

  const handleClickSharePlan = () => {
    navigate("/home/plan-share-screen");
  };
  const handleCloseAddUser = () => {
    setIsClicked(false);
  };
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const FilterModal = ({ open, handleClose }) => {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='filter-modal-title'
        aria-describedby='filter-modal-description'>
        <Box
          sx={{
            position: "absolute",
            top: "32%",
            left: "92%",
            transform: "translate(-25%, -50%)",
            width: 90,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
          }}>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              cursor: "pointer"
            }}>
            Recent Plan
          </Typography>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
              cursor: "pointer"
            }}>
            Old Plan
          </Typography>
        </Box>
      </Modal>
    );
  };
  useEffect(() => {
    getPlan();
  }, []);
  const [planData, setPlanData] = useState([]);
  const getPlan = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
          setCardView(false);
        }
        const userId = localStorage.getItem("user_id");

        const filteredPlanData = response.data.filter(
          (plan) => plan.user_id === userId
        );

        setPlanData(filteredPlanData);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleSortByRecentUser = () => {
    // Sort userData by createdAt in descending order
    const sortedData = [...planData].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
    setPlanData(sortedData);
    handleClose();
  };
  const handleSortByExistingUser = () => {
    // Sort userData by createdAt in ascending order
    const sortedData = [...planData].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
    setPlanData(sortedData);
    handleClose();
  };

  return (
    <div>
      <Typography
        sx={{
          fontFamily: "Inter, sans-serif",
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: "21px",
          textAlign: "left",
          marginBottom: "10px",
        }}>
        Share Plan
      </Typography>
      {!emptyUser && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 0",
          }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "21px",
              textAlign: "left",
            }}>
            My Plans
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label='grid view'
              sx={{ color: "black" }}
              onClick={() => {
                setCardView(true);
                setEmptyUser(false);
                setGridView(false);
              }}>
              <DashboardIcon fontSize='small' />
            </IconButton>
            <IconButton aria-label='list view' sx={{ color: "black" }}>
              <ViewListIcon
                fontSize='small'
                onClick={() => {
                  setGridView(true);
                  setEmptyUser(false);
                  setCardView(false);
                }}
              />
            </IconButton>
            <IconButton
              aria-label='filter'
              sx={{ color: "black" }}
              onClick={handleOpen}>
              <TuneIcon fontSize='small' />
            </IconButton>
          </Box>
        </Box>
      )}

      {emptyUser && <EmptyPlanShare />}
      {cardView && <CardShare planData={planData} getPlan={getPlan} />}
      {gridView && <ShareTable planData={planData} getPlan={getPlan} />}
      {/* <FilterModal open={open} handleClose={handleClose} /> */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}>
        <Box
          sx={{
            width: 90,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
          }}>
          <Typography
            id='filter-popover-title'
            variant='h6'
            component='h2'
            onClick={handleSortByRecentUser}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              cursor: "pointer"
            }}>
            Recent Plan
          </Typography>
          <Typography
            id='filter-popover-title'
            variant='h6'
            component='h2'
            onClick={handleSortByExistingUser}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
              cursor: "pointer"
            }}>
            Existing Plan
          </Typography>
        </Box>
      </Popover>
    </div>
  );
}

export default SharePlan;
